import React, { useRef } from 'react';
import { buildURL } from 'react-imgix';

import useRect from '@zego/hooks/useRect';
import { nextWidth } from '@zego/imgixUtils';

function findClosest(choices, value) {
  if (value < choices[0]) {
    return choices[0];
  }

  for (let i = 0; i < choices.length; i++) {
    if (value > choices[i]) {
      continue;
    }
    return choices[i];
  }
  return choices[choices.length - 1];
}

const toFixed = (dp, value) => +value.toFixed(dp);

export default function FluidBackgroundImageBase({
  imgixParams = {},
  src,
  ratios = [1 / 4, 1 / 3, 1 / 2, 2 / 3, 1, 3 / 2, 2],
  children,
  ...props
}) {
  const ref = useRef();
  const rect = useRect(ref);

  let extraProps = {};

  if (rect) {
    const closestRatio = findClosest(ratios, rect.width / rect.height);
    const closestWidth = nextWidth(rect.width);
    const dpr = toFixed(2, global.devicePixelRatio || 1);

    const generatedSrc = buildURL(src, {
      fit: 'crop',
      w: closestWidth,
      h: closestWidth / closestRatio,
      dpr,
      ...imgixParams,
    });

    extraProps.style = {
      backgroundPosition: 'center center',
      backgroundImage: `url(${generatedSrc})`,
      backgroundSize: 'cover',
    };
  }

  return (
    <div ref={ref} {...extraProps} {...props}>
      {children}
    </div>
  );
}
